module.exports = __webpack_public_path__ + "static/media/素炸鹽酥雞便當.ae17041e.jpg";